<template>
    <div id="questionnaire" class="w-full">
        <div v-if="this.datas.type == 'box'">
            <boxType v-bind:datas="this.datas"></boxType>
        </div>
        <div v-else-if="this.datas.type == 'gallery'">
            <gallery v-bind:datas="this.datas"></gallery>
        </div>
        <div v-else-if="this.datas.type == 'input'">
            <inputType v-bind:datas="this.datas"></inputType>
        </div>
        <div v-else-if="this.datas.type == 'result'">
            <result v-bind:datas="this.datas"></result>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            datas: Object
        }
    }
</script>